import "./index.scss";

import React, { Component } from "react";
import {
  changeMenu,
  getMaxHeightExpanded,
  setMaxHeightExpanded
} from "./../../actions/themeActions";

import Card from "./../Card";
import CardContainer from "../CardContainer";
import Loading from "../Loading";
import PropTypes from "prop-types";
import Title from "../Title";
import { connect } from "react-redux";
import { getAttendants } from "../../actions/dataActions";
import {Calendar, momentLocalizer} from "react-big-calendar";
import moment from "moment";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

//Redux
const localizer = momentLocalizer(moment);
const messages = {
  allDay: "Dia todo",
  previous: "Anterior",
  next: "Próximo",
  today: "Hoje",
  month: "Mês",
  week: "Semana",
  day: "Dia",
  agenda: "Agenda",
  date: "Data",
  time: "Hora",
  event: "Evento",
  showMore: total => `+ ${total} eventos`
};
class index extends Component {


  constructor(props) {
    super(props);
    this.iscalendarferias = true;
    this.iscalendarausencia = true;
  }

  maxHeight = () => {
    const { setMaxHeightExpanded, getMaxHeightExpanded } = this.props;
    let MAX_HEIGHT_EXPANDED;

    if (window.innerWidth > 895) {
      MAX_HEIGHT_EXPANDED = `${document.body.clientHeight -
        document.getElementById("header").offsetHeight -
        document.querySelector(".section").offsetHeight -
        180}`;
    }

    setMaxHeightExpanded(MAX_HEIGHT_EXPANDED);
    getMaxHeightExpanded();
  };

  componentDidMount() {
    this.props.changeMenu(this.props.location.pathname.slice(1));
    this.props.getAttendants();
    this.maxHeight();
    window.addEventListener("resize", this.maxHeight);
  }

  titleize(text) {
    let words = text.toLowerCase().split(" ");

    for (let a = 0; a < words.length; a++) {
      let w = words[a];
      if (words[a].length > 2) {
        words[a] = w[0].toUpperCase() + w.slice(1);
      }
    }

    return words.join(" ");
  }

  dateAdjust(text) {
    let date = text.split("-");
    return `${date[2]}/${date[1]}/${date[0]}`;
  }

  render() {
    const {
      attendants,
      theme,
      showMenu,
      loadingAttendants,
      maxHeightExpanded
    } = this.props;
    const { id } = this.props.match.params;

    let attendantsAbsenceArr = [];
    attendants.map(attendant =>
      attendant.ferias.length > 0 || attendant.ausencias.length > 0
        ? attendantsAbsenceArr.push({
            id: attendantsAbsenceArr.length,
            name: this.titleize(attendant.pessoa.nome),
            vacations: attendant.ferias.filter((ele,i)=> {return attendant.ferias.findIndex(x => x.id == ele.id)===i}),
            absence: attendant.ausencias
          })
        : null
    );
    console.log(attendantsAbsenceArr);
    let eventosFerias = [];
    let eventosAusencias = [];

    attendantsAbsenceArr.map( att => {

      att.vacations.map(vac => {

        vac.feriasPeriodos.map(fp => {
          eventosFerias.push({
            id: eventosFerias.length,
            title: 'Férias de ' + att.name,
            allDay: true,
            start: fp.dataInicio+":23:59:59",
            end: fp.dataFim+":23:59:59",
          })
        })
      })

    });

    attendants.map(attendant =>
         attendant.ausencias.length > 0 ?

            attendant.ausencias.map(aus =>
                eventosAusencias.push({
                  id: eventosAusencias.length,
                  title: 'Ausência de ' + attendant.pessoa.nome,
                  allDay: true,
                  start: aus.inicio,
                  end: aus.fim,
                })
            )
            :null
    );

    console.log(attendants);

    return (
      <div id="Absence" className={showMenu ? `blur` : ""}>
      <Tabs>
        <TabList>
          <Tab>Todos</Tab>
          <Tab>Férias</Tab>
          <Tab>Ausências</Tab>
        </TabList>
        <TabPanel>
        <Title text={`Férias e afastamentos`} type={`SECTION`} theme={theme} />
        {loadingAttendants ? (
          <Loading />
        ) : id ? (
          <div className="line">

            <Card
              name={attendantsAbsenceArr[id].name}
              type={"absence-expanded"}
              absence={attendantsAbsenceArr[id].absence}
              vacations={attendantsAbsenceArr[id].vacations}
              theme={theme}
            />

          </div>
        ) : (
          <CardContainer
            data={attendantsAbsenceArr}
            theme={theme}
            cardAbsence
          />
        )}
        </TabPanel>
      <TabPanel>

        <div>
          <Calendar
              localizer={localizer}
              defaultView="month"
              events={
                eventosFerias
              }
              style={{minHeight: "80vh"}}
              messages={messages}
          />

        </div>
          </TabPanel>
      <TabPanel>
        <div>
          <Calendar
              localizer={localizer}
              defaultView="month"
              events={
                eventosAusencias
              }
              style={{minHeight: "80vh"}}
              messages={messages}
          />

        </div>
      </TabPanel>
      </Tabs>
      </div>
    );
  }
}

index.propTypes = {
  getAttendants: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  loadingAttendants: PropTypes.bool.isRequired,
  showMenu: PropTypes.bool.isRequired,
  changeMenu: PropTypes.func.isRequired,
  getMaxHeightExpanded: PropTypes.func.isRequired,
  setMaxHeightExpanded: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  attendants: state.data.attendants,
  loadingAttendants: state.data.loadingAttendants,
  maxHeightExpanded: state.theme.maxHeightExpanded,
  showMenu: state.theme.showMenu
});

export default connect(mapStateToProps, {
  changeMenu,
  getAttendants,
  getMaxHeightExpanded,
  setMaxHeightExpanded
})(index);
